/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Top_Up_Stub_HintInputs */

const cs_billing_top_up_stub_hint = /** @type {(inputs: Billing_Top_Up_Stub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platební brána není nastavena — vznikne čekající záznam ke schválení adminem.`)
};

const en_billing_top_up_stub_hint = /** @type {(inputs: Billing_Top_Up_Stub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment gateway is not configured — this creates a pending ledger entry for admin confirmation.`)
};

/**
* | output |
* | --- |
* | "Payment gateway is not configured — this creates a pending ledger entry for admin confirmation." |
*
* @param {Billing_Top_Up_Stub_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_top_up_stub_hint = /** @type {((inputs?: Billing_Top_Up_Stub_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Top_Up_Stub_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_top_up_stub_hint(inputs)
	return cs_billing_top_up_stub_hint(inputs)
});